import { Size } from "../generated/base/ratios";

export function buildQueryString(params: { [key: string]: string }) {
	return (
		'?' +
		Object.keys(params)
			.map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
			.join('&')
	);
}

export const sizeToRadiusMap:{[key in Size]: string} = {
	'12XL': 'cornerRadiusLarge',
	'11XL': 'cornerRadiusLarge',
	'10XL': 'cornerRadiusLarge',
	'9XL': 'cornerRadiusLarge',
	'8XL': 'cornerRadiusLarge',
	'7XL': 'cornerRadiusLarge',
	'6XL': 'cornerRadiusLarge',
	'5XL': 'cornerRadiusMedium',
	'4XL': 'cornerRadiusMedium',
	'3XL': 'cornerRadiusMedium',
	'2XL': 'cornerRadiusMedium',
	'XL': 'cornerRadiusMedium',
	'large': 'cornerRadiusSmall',
	'medium': 'cornerRadiusSmall',
	'small': 'cornerRadiusXS',
	'XS': 'cornerRadiusXS',
	'2XS': 'cornerRadiusXS',
}